<template lang="pug"></template>
<script>
import Vue from 'vue'
export default {
  props: {
    plan_id: String,
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("user/setPlanId", this.plan_id)
  },
  watch: {
  },
}
</script>
